import React from 'react';
import '../assets/css/Spinner.css';

const Spinner = () => (
  <div className="lds-ripple">
    <div />
    <div />
  </div>
);

export default Spinner;
